import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import {
  loadPublishedPostByUsername,
  loadPublishedPostById,
  clearPost
} from 'state/actions/posts'
import { isFollowingTags } from 'state/actions/follow'
import { loadResponses, clearResponses } from 'state/actions/responses'
import { clearDraft } from 'state/actions/drafts'
import { clearEmbeds } from 'state/actions/embeds'

import universal from 'react-universal-component'
import { loadGroup } from 'state/actions/groups'
import { getPostSummaryText } from 'lib/getPostSummary'
const component = universal(props => import('./ViewPublishedPostPage'))

class AsyncViewPublishedPostPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  createPageHeadInfo(getState, opts, callback) {
    let {
      instance: { value: { domainName, instanceName } },
      post: {
        value: post
      }
    } = getState()
    const {
      title,
      image,
      created,
      modified,
      author,
      group,
      tags,
      language,
      type
    } = post

    const summary = getPostSummaryText(post)

    return {
      title: title,
      keywords: tags,
      type: type || 'article',
      created,
      modified,
      group,
      author,
      description: summary.slice(0, 255),
      instance: instanceName,
      domain: domainName,
      image,
      locale: language === 'en' ? 'en_GB' : 'ar_IQ'
    }
  }

  async prepareAsyncData(dispatch, getState, opts) {
    try {
      dispatch(clearDraft())
    } catch (clearErr) {
      log.error(clearErr)
    }
    dispatch(clearResponses())
    dispatch(clearPost())
    dispatch(clearEmbeds())    
    return super.prepareAsyncData(dispatch, getState, opts)
  }
  
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    let {
      location: { payload: { username, name, group, post: postId } },
      session: { value: profile }
    } = getState()
    if (group) {
      await loadGroup({ _id: group })(dispatch, getState, opts)
    }

    name = decodeURIComponent(name)
    try {
      const post = username
        ? await loadPublishedPostByUsername({ username, name })(
          dispatch,
          getState,
          opts
        )
        : await loadPublishedPostById({
          _id: postId
        })(dispatch, getState, opts)

      if (post) {
        // start loading conversations about the post as soon as possible, as
        // this may well be the bit we have to wait longest for ...
        try {
          await loadResponses({ _id: post._id, depth: 5 })(
            dispatch,
            getState,
            opts
          )
        } catch (responsesErr) {
          log.error(responsesErr)
        }
        if (profile) {
          try {
            const tags = await isFollowingTags({
              entities: post.tags,
              followerId: profile._id
            })(dispatch, getState, opts)
          } catch (tagsErr) {
            log.error(tagsErr)
          }
        }
      }
    } catch (err) {
      log.error(err)
    }
  }
}

export default new AsyncViewPublishedPostPage()
